var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconExternalLink = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M9.5 3.5H19.5L19.6069 3.50564L19.7926 3.54348L19.9635 3.61361L20.1042 3.70301L20.2071 3.79289L20.2821 3.87668L20.3665 4.00047L20.4248 4.11881L20.4668 4.24372L20.4958 4.40843L20.5 4.5V14.5C20.5 15.0523 20.0523 15.5 19.5 15.5C19.0091 15.5 18.6008 15.1462 18.5161 14.6798L18.5 14.5V6.912L6.20711 19.2071C5.81658 19.5976 5.18342 19.5976 4.79289 19.2071C4.44576 18.86 4.40719 18.3211 4.67718 17.9314L4.79289 17.7929L17.086 5.498L9.5 5.5C8.94772 5.5 8.5 5.05228 8.5 4.5C8.5 4.00908 8.85375 3.60078 9.32025 3.51611L9.5 3.5Z", fill: "black" }))),
        alt: 'Icon ExternalLink',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconExternalLink;
//# sourceMappingURL=index.js.map